import React, { useState } from 'react';
import DssManager from '../Map/DssManager';
import './DssCenter.css';

export default function DssCenter({ fields, sensors, token, language }) {
    const isEN = language === 'en';
    const [openId, setOpenId] = useState(null);

    if (!fields || fields.length === 0) {
        return (
            <div className="dssc-empty">
                <span>🌾</span>
                <p>{isEN ? 'No fields found.' : 'Tarla bulunamadı.'}</p>
            </div>
        );
    }

    return (
        <div className="dssc-wrap">
            <div className="dssc-header">
                <h2 className="dssc-title">🧩 {isEN ? 'Decision Support System' : 'Karar Destek Sistemi'}</h2>
                <p className="dssc-sub">
                    {isEN
                        ? 'Configure sensor-based irrigation rules for each field.'
                        : 'Her tarla için sensör tabanlı sulama kurallarını yapılandırın.'}
                </p>
            </div>

            <div className="dssc-list">
                {fields.map(field => {
                    const isOpen = openId === field.id;
                    return (
                        <div key={field.id} className={`dssc-field-card ${isOpen ? 'dssc-card-open' : ''}`}>
                            {/* Field header — click to toggle */}
                            <button className="dssc-field-toggle" onClick={() => setOpenId(isOpen ? null : field.id)}>
                                <div className="dssc-field-info">
                                    <span className="dssc-field-icon">🌾</span>
                                    <div>
                                        <div className="dssc-field-name">{field.name}</div>
                                        {field.crop && (
                                            <div className="dssc-field-meta">
                                                {field.crop}{field.area ? ` · ${field.area} ha` : ''}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <span className={`dssc-chevron ${isOpen ? 'open' : ''}`}>▼</span>
                            </button>

                            {/* DSS Manager — expanded */}
                            {isOpen && (
                                <div className="dssc-dss-body">
                                    <DssManager
                                        fieldId={field.id}
                                        fieldName={field.name}
                                        cropType={field.cropType}
                                        elevation={field.elevation}
                                        fieldKc={field.kc}
                                        latitude={field.geometry?.coordinates?.[0]?.[0]?.[1] ?? 36}
                                        fieldSensors={(sensors || []).filter(s => s.fieldId === field.id)}
                                        token={token}
                                        language={language}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
